import { observer } from "mobx-react-lite";
import Link from "next/link";
import { useTranslations } from "next-intl";

import GoogleIcon from "@/(auth)/components/icons/Google.svg";
import { FormButton } from "@/components/form/FormButton";
import { Icon } from "@/components/icons/Icon";
import { useStore } from "@/store";
import { trackEvent } from "@/utils/trackEvent";

export const LoginPanel = observer(function LoginPanel() {
  const { doc, signInFlow } = useStore();
  const t = useTranslations();

  const handleSignInWithGoogle = () => {
    trackEvent("google_auth_login_clicked", {});
    signInFlow.signInWithProviderAndRedirect("google");
  };

  return (
    <div className="w-full pt-2.5 p-1.25">
      {!doc?.publicRead ? (
        <div className="mb-2.5 px-1.25 font-geist text-size-[16px] leading-[1.2]">
          {t.rich("requestPermission.loginToView", {
            strong: (text) => <strong>{text}</strong>,
          })}
        </div>
      ) : (
        <div className="flex mb-2.5 gap-[7px]">
          <Icon name="CorcaLogo" width={42} height={42} />
          <div className="flex-1">
            <h3 className="text-base tracking-tight font-semibold leading-none pt-[5px] pb-[2px]">
              {t("loginPanel.title")}
            </h3>
            <p className="mb-2.5 font-geist text-size-[16px] leading-[1.2]">
              {t("loginPanel.subtitle")}
            </p>
          </div>
        </div>
      )}
      <FormButton
        className="w-full text-xs h-8.5 mt-1.25 tracking-tight rounded-lg"
        onClick={handleSignInWithGoogle}
      >
        <GoogleIcon className="inline-block -translate-y-[1px] mr-1.5" />
        {t("auth.login.googleSSOButton.text")}
      </FormButton>
      <Link
        href="/login"
        className="w-full block mt-1.25"
        onClick={() => signInFlow.redirectToLogin()}
      >
        <FormButton type="button" className="w-full text-xs h-8.5 tracking-tight rounded-lg">
          {t("userMenu.logIn")}
        </FormButton>
      </Link>
      <Link href="/signup" className="w-full block" onClick={() => signInFlow.redirectToSignUp()}>
        <FormButton
          variant="accent"
          type="submit"
          className="w-full text-xs h-8.5 mt-1.25 tracking-tight rounded-lg"
        >
          {t("userMenu.signIn")}
        </FormButton>
      </Link>
    </div>
  );
});
